export default __webpack_public_path__ + "static/media/notfound.ac24b1dc.jpg";